import React from 'react';

export interface Option {
  value: string;
  label: string;
}

export interface SelectFieldProps {
  label: string;
  value: string | null;
  onChange: (value: string) => void;
  options: readonly Option[];
  error?: string;
  placeholder?: string;
  required?: boolean;
  id?: string;
  disabled?: boolean;
}

/**
 * Reusable select dropdown field component
 */
export const SelectField: React.FC<SelectFieldProps> = ({
  label,
  value,
  onChange,
  options,
  error,
  placeholder = 'Select an option',
  required = false,
  id,
  disabled = false,
}) => {
  const fieldId = id || `select-field-${label.toLowerCase().replace(/\s+/g, '-')}`;
  const errorId = `${fieldId}-error`;
  const currentValue = value || '';

  return (
    <div style={{ marginBottom: '15px' }}>
      <label 
        htmlFor={fieldId} 
        style={{ 
          display: 'block', 
          marginBottom: '5px', 
          fontWeight: required ? 'bold' : 'normal' 
        }}
      >
        {label}
        {required && <span style={{ color: 'red', marginLeft: '4px' }} aria-label="required">*</span>}
      </label>
      <select
        id={fieldId}
        value={currentValue}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        disabled={disabled}
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={error ? errorId : undefined}
        style={{
          width: '100%',
          padding: '8px',
          fontSize: '14px',
          border: error ? '1px solid #dc3545' : '1px solid #ccc',
          borderRadius: '4px',
          backgroundColor: disabled ? '#f5f5f5' : 'white',
          cursor: disabled ? 'not-allowed' : 'pointer',
          boxSizing: 'border-box',
        }}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && (
        <div
          id={errorId}
          role="alert"
          style={{
            color: '#dc3545',
            fontSize: '12px',
            marginTop: '4px',
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
};

